import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M29.632 0c1.304 0 2.367 1.033 2.367 2.307v27.384c0 1.274-1.062 2.309-2.367 2.309H2.359C1.057 32 0 30.965 0 29.691V2.307C-.001 1.033 1.057 0 2.359 0zM9.148 11.637h-4.77V27h4.77zm12.134-.381c-2.32 0-3.874 1.273-4.51 2.481h-.065v-2.1h-4.569V27h4.76v-7.599c0-2.004.379-3.945 2.859-3.945 2.446 0 2.476 2.291 2.476 4.073V27H27v-8.426c0-4.137-.892-7.318-5.717-7.318M6.764 4A2.765 2.765 0 0 0 4 6.769a2.765 2.765 0 0 0 2.765 2.769 2.767 2.767 0 0 0 2.762-2.77A2.767 2.767 0 0 0 6.764 4" }, null, -1)
  ])))
}
export default { render: render }